import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MaterialInput from "@Shared/components/inputs/material-input.vue";
import PhoneInput from "@Shared/components/inputs/phone-input.vue";
import TimezoneSelect from "@Shared/components/inputs/timezone-select.vue";
import Select2 from "@Shared/components/inputs/select2.vue";
import { MORTGAGE_FRANCHISE } from "@Shared/js/enum";
import { validationMixin } from "vuelidate";
import { required, email } from "vuelidate/lib/validators";
import RegistrationTokenLoader from "./registration-token-loader.vue";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import { sameAsWithLabel, validPassword } from "@Shared/@Utils/validation-rules";
import PasswordInput from "@Shared/components/inputs/password-input.vue";
import { TOS_EXTERNAL_LINK } from "@Shared/@Utils/constants";
import { isEmpty, map, set } from "lodash";
import { validateToken as validateTokenRequest } from "@Broker/@Modules/main/api/account-api";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "PersonalDetailsStep",
  components: {
    MaterialInput,
    PhoneInput,
    RegistrationTokenLoader,
    PasswordInput,
    TimezoneSelect,
    Select2,
    SimpleButton
  },
  mixins: [validationMixin],
  props: {
    loadingState: {
      type: Object,
      required: true
    }
  },
  validations() {
    return {
      formData: {
        accountType: {
          required
        },
        brokerage: {
          agentLicenseId: {
            required
          },
          brokerageLicenseId: {
            required
          },
          franchise: {
            required
          },
          name: {
            required
          }
        },
        email: {
          required,
          email
        },
        familyName: {
          required
        },
        givenName: {
          required
        },
        password: {
          required,
          validPassword
        },
        passwordRepeat: {
          required,
          sameAs: sameAsWithLabel("Password above")("password")
        },
        phoneNumber: {
          required
        },
        timezone: {
          required
        }
      },
      terms: {
        required(value) {
          return value;
        }
      }
    };
  },
  data() {
    return {
      validatedTokenData: null,
      formData: {
        accountType: "",
        brokerage: {
          agentLicenseId: "",
          brokerageLicenseId: "",
          franchise: "",
          name: ""
        },
        currentSubdomain: window.location.pathname.replace("/", ""),
        email: "",
        familyName: "",
        givenName: "",
        middleName: "",
        password: "",
        passwordRepeat: "",
        phoneNumber: "",
        timezone: "",
        token: "",
        locale: this.$route.query.locale
      },
      terms: false,
      fromRegistration: false
    };
  },
  computed: {
    TOS_EXTERNAL_LINK() {
      return TOS_EXTERNAL_LINK();
    },
    loading() {
      return this.loadingState.creating.loading;
    },
    loadingStatus() {
      return this.loadingState.creating.status;
    },
    select2Options() {
      return {
        closeOnSelect: true,
        placeholder: `${this.$t("account.form.brokerage.franchise")}*`
      };
    },
    franchiseOptions() {
      return map(MORTGAGE_FRANCHISE, (val, key) => ({
        text: val,
        id: key
      }));
    },
    isBrokerGroupAccount() {
      return this.ACCOUNT_TYPE_IS_BROKER_GROUP(this.formData.accountType);
    },
    isAgentGroupAccount() {
      return this.ACCOUNT_TYPE_IS_AGENT_GROUP(this.formData.accountType);
    },
    isFrenchLanguage() {
      return this.$root.$i18n.locale === "fr-CA";
    }
  },
  async beforeMount() {
    await this.validateToken();
    this.loadInvitation();
  },
  methods: {
    async validateToken() {
      const query = this.$route.query;
      const token = query.token;
      if (!token) {
        this.validatedTokenData = false;
        return;
      }
      try {
        const response = await validateTokenRequest(token);
        this.validatedTokenData = (response == null ? void 0 : response.status) !== 401;
      } catch (error) {
        this.validatedTokenData = (error == null ? void 0 : error.status) !== 401;
      }
    },
    handleSubmit() {
      if (this.$v.$invalid || !this.terms) return;
      this.$emit("submit", this.formData);
    },
    loadInvitation() {
      const query = this.$route.query;
      if (isEmpty(query)) return;
      this.fromRegistration = true;
      if (query.locale) {
        this.$root.$i18n.locale = query.locale;
      }

      // No validation is needed, backend validates that the token
      // is signed by us

      const token = query.token;
      if (!token) return;

      // JWT Payload is the middle part of the token between the two dots   xxx.yyy.zzz (yyy is the payload)
      const payload = token.split(".")[1];

      // Because it is in base64, we need to decode it
      const decodedPayload = JSON.parse(atob(payload));
      const data = {
        familyName: decodedPayload.familyName,
        givenName: decodedPayload.givenName,
        email: decodedPayload.email,
        accountType: decodedPayload.userType,
        phoneNumber: decodedPayload.phoneNumber,
        brokerage: {
          brokerageLicenseId: decodedPayload.licenseId,
          name: decodedPayload.name,
          franchise: decodedPayload.franchise
        },
        token
      };
      this.formData = _objectSpread(_objectSpread({}, this.formData), data);
      this.$nextTick(() => {
        this.$v.$touch();
      });
    },
    handleInvitationFieldChange(path, value) {
      if (this.fromRegistration) return;
      set(this.formData, path, value);
    }
  }
});